
<script setup lang="ts">
import { useToastStore } from '@/stores/toast.store';

const toastStore = useToastStore();
</script>
<template>
    <template v-for="toast in toastStore.toasts" :key="toast.id">
        <transition name="toast">
            <div class="toast-container" :class="`toast-${toast.type}`" @click="toastStore.remove(toast.id)">
                <div class="toast-content">
                    <div class="toast-icon">
                        <img v-if="toast.type === 'success'" src="/icons/icon-success.svg" alt="" />
                        <img v-else-if="toast.type === 'error'" src="/icons/icon-fail.svg" alt="" />
                        <img v-else-if="toast.type === 'warning'" src="/icons/icon-warning.svg" alt="" />
                        <img v-else src="/icons/icon-info.svg" alt="" />
                    </div>
                    <div class="toast-message">{{ toast.message }}</div>
                    <button class="toast-close" @click.stop="toastStore.remove(toast.id)">×</button>
                </div>
            </div>
        </transition>
    </template>
</template>

<style scoped>
.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10000;
    min-width: 300px;
    max-width: 500px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    cursor: pointer;
}

.toast-content {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    gap: 12px;
}

.toast-success {
    background-color: #10b981;
    color: white;
}

.toast-error {
    background-color: #ef4444;
    color: white;
}

.toast-warning {
    background-color: #f59e0b;
    color: white;
}

.toast-info {
    background-color: #3b82f6;
    color: white;
}

.toast-icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toast-icon img {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(1);
}

.toast-message {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
}

.toast-close {
    flex-shrink: 0;
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transition: opacity 0.2s;
}

.toast-close:hover {
    opacity: 1;
}

.toast-enter-active {
    transition: all 0.3s ease-out;
}

.toast-leave-active {
    transition: all 0.3s ease-in;
}

.toast-enter-from {
    opacity: 0;
    transform: translateX(100%);
}

.toast-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>
